export const getRoomState = (state: any) => state.room
